import workspaceQuery from '../../../graphql/queries/sales/ImportedWebOrderWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/ImportedWebOrderListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/ImportedWebOrderQuery.graphql';
import mutationQuery from '../../../graphql/mutations/sales/ImportedWebOrderMutation.graphql';
import fragment from '../../../graphql/fragments/sales/ImportedWebOrderFragment.graphql';
import aggregateQuery from '../../../graphql/queries/sales/ImportedWebOrderAggregateQuery.graphql';

import { workspace } from '../../../actions/sales/ImportedOrderWorkspaceAction';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const ImportedWebOrder: EntityType = {
  type: 'ImportedWebOrder',
  title: 'Web Orders',
  formTitle: 'Imported Web Order',
  workspaceUrl: '/Sales/Channel/ImportedWebOrder/Workspace/',
  formUrl: '/Sales/Channel/ImportedWebOrder/Details/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'orderReference',
  },
  fragment,
  aggregate: aggregateQuery,
  screenReference: 'IMPORTED_WEB_ORDERS',
  actions: workspace,
  operations: ALLOW_VIEW,
};

export default ImportedWebOrder;
